<div class="dialog">

  <div class="message">
    <h2 class="info-title">Stored Filters</h2>
  </div>

  <div class="filter-list">
    @for (filter of filterService.storedFilters; track filter.id || filter.name) {
      <div class="filter-item selectable" (click)="selectFilter(filter.name)" [class.selected]="filter === filterService.activeFilter()">
        <div class="filter-item-main">
        <div class="filter-name-with-icon"
          [class.editing-icon]="editingIconKey === filterKey(filter)"
          [class.editing-name]="editingFilterKey === filterKey(filter)">
          @if (editingFilterKey !== filterKey(filter)) {
            <div class="filter-icon-edit" (click)="beginEditIcon($event, filter)" title="Filter icon">
              @if (editingIconKey !== filterKey(filter)) {
                <div class="filter-icon-display">
                  @for (icon of filterDisplayIcons[filterKey(filter)]; track icon) {
                    <span class="icon" [class]="'icon icon-' + icon"></span>
                  } @empty {
                    <span class="icon icon-filter filter-icon-placeholder"></span>
                  }
                </div>
              } @else {
                <app-select class="filter-icon-select" [displayMode]="'prefixAndText'" [alignLeft]="true" [fullWidth]="true"
                  [(ngModel)]="editingIconValue" (selectedValueChange)="onIconSelected(filter, $event)"
                  (click)="$event.stopPropagation()">
                  <app-option [value]="autoIconValue" [text]="'Auto'"></app-option>
                  @for (icon of iconAllowlist; track icon) {
                    <app-option [value]="icon" [text]="icon" [iconClass]="icon"></app-option>
                  }
                </app-select>
              }
            </div>
          }
          @if (editingIconKey !== filterKey(filter)) {
            <div class="filter-name" [title]="filter.name">
              @if (editingFilterKey !== filterKey(filter)) {
                <div class="filter-name-display" (click)="beginRename($event, filter)">{{ filter.name }}</div>
              } @else {
                <input type="text" class="form-control filter-name-input" placeholder="Filter Name" [attr.maxlength]="maxFilterNameLength"
                  [(ngModel)]="filter.name" (keydown)="nameChangeKeyDown($event, filter)" (blur)="finishRename($event, filter)"
                  (click)="$event.stopPropagation()">
              }
            </div>
          }
        </div>
        <div class="filter-metadata">
          <div><span class="extra-info">Version:</span> {{ filter.version }}</div>
          <div><span class="extra-info">Updated:</span> {{ filter.lastUpdated | date:'yyyy-MM-dd' }}</div>
        </div>
        <div class="filter-metadata">
          <div>
            <span class="extra-info">Local:</span>
            @if (filter.filter.id) {
              <span> {{ filter.filter.id }}</span>
              @if (filter.snapshotUploaded) {
                <a [href]="null" class="filter-share-link" (click)="copyShareLink($event, filter)" title="Copy online share link">
                  <span class="icon icon-link"></span>
                </a>
              }
            } @else {
              No
            }
          </div>
          <div>
            <span class="extra-info">Account:</span>
            @if (uploadingFilter === filter) {
              ...
            } @else if (filter.id) {
              <span> {{ filter.id }}</span>
            } @else {
              No
            }
          </div>
        </div>
        @if (customRuleTotal(filter.filter) || cosmeticRuleTotal(filter.filter)) {
          <div class="filter-metadata hidden-mobile">
            <div><span class="extra-info">Custom rules:</span> {{ customRuleTotal(filter.filter) }}</div>
            <div><span class="extra-info">Cosmetic rules:</span> {{ cosmeticRuleTotal(filter.filter) }}</div>
          </div>
        }
        <div class="filter-actions tooltip-buttons">
          @if (loggedIn) {
            <app-tooltip-wrapper [right]="true" class="btn-tooltip">
              <button type="button" class="btn" (click)="upload($event, filter)" [disabled]="downloadingFilter || uploadingFilter">
                <span class="icon icon-upload"></span>
              </button>
              <ng-template #tooltip>
                Upload to your account
              </ng-template>
            </app-tooltip-wrapper>
          }
          <app-tooltip-wrapper [right]="true" class="btn-tooltip">
            <button type="button" class="btn" (click)="duplicate($event, filter)" [disabled]="downloadingFilter || copyingSections">
              <span class="icon icon-copy"></span>
            </button>
            <ng-template #tooltip>
              Clone
            </ng-template>
          </app-tooltip-wrapper>
          @if (copyingSections && filter === fromFilter) {
            <app-tooltip-wrapper [right]="true" class="btn-tooltip">
              <button type="button" class="btn" (click)="copySections($event, filter)" [disabled]="downloadingFilter" [disabled]="true">
                <span class="icon icon-upload2"></span>
              </button>
              <ng-template #tooltip>
                Copying sections from filter
              </ng-template>
            </app-tooltip-wrapper>
          }
          @if (!copyingSections) {
            <app-tooltip-wrapper [right]="true" class="btn-tooltip">
              <button type="button" class="btn" (click)="copySections($event, filter)" [disabled]="downloadingFilter">
                <span class="icon icon-upload2"></span>
              </button>
              <ng-template #tooltip>
                Copy sections to another filter
              </ng-template>
            </app-tooltip-wrapper>
          }
          @if (copyingSections && filter !== fromFilter) {
            <app-tooltip-wrapper [right]="true" class="btn-tooltip">
              <button type="button" class="btn" (click)="pasteSections($event, filter)" [disabled]="downloadingFilter">
                <span class="icon icon-download2"></span>
              </button>
              <ng-template #tooltip>
                Paste sections to this filter
              </ng-template>
            </app-tooltip-wrapper>
          }
          @if (filterService.storedFilters.length > 1) {
            <app-tooltip-wrapper [right]="true" class="btn-tooltip">
              <button type="button" class="btn" (click)="remove($event, filter)" [disabled]="downloadingFilter">
                <span class="icon icon-bin"></span>
              </button>
              <ng-template #tooltip>
                Remove from browser
              </ng-template>
            </app-tooltip-wrapper>
          }
        </div>
        </div>
        @if (filter.importedFromFilterId) {
          <div class="filter-item-imported">
            <span class="extra-info">Imported from </span>
            @if (filter.importedFromFilterName) {
              <span>{{ filter.importedFromFilterName }}</span>
              <span class="filter-id-detail">({{ filter.importedFromFilterId }})</span>
            } @else {
              <span>{{ filter.importedFromFilterId }}</span>
            }
            @if (filter.importedFromUsername) {
              <span class="extra-info"> from </span> <span>{{ filter.importedFromUsername }}</span>
            }
            <a [href]="null" class="filter-share-link" (click)="refreshFromOnline($event, filter)" title="Re-download">
              <span class="icon icon-loop2"></span>
            </a>
          </div>
        }
      </div>
    }
  </div>

  <button type="button" class="btn create-new-btn" (click)="createNew()">
    Create New
  </button>

  @if (renameError) {
    <div class="message">
      {{ renameError }}
    </div>
  }

  @if (errorUploadingFilter) {
    <div class="message">
      An error occurred trying to update the filter: {{ errorUploadingFilter }}
      <br />Please try again later. If the problem persists, contact us on Discord or the official forum thread.
    </div>
  }

  @if (!loggedIn) {
    <div class="message">
      <a [href]="null" class="action-link" (click)="login($event)">Log in</a> on pathofexile.com to retrieve account filters.
    </div>
  } @else {
    @if (retrievingFilters) {
      <div class="message">
        Retrieving filters...
      </div>
    } @else {
      @if (errorRetrievingFilters) {
        <div class="message">
          An error occurred trying to retrieve your filters from your pathofexile.com account: {{ errorRetrievingFilters }}
          <br />Please try again later. If the problem persists, contact us on Discord or the official forum thread.
        </div>
      } @else if (toolAccountFilters.length === 0) {
        <div class="message">
          There are no filters on your pathofexile.com account which have not yet been downloaded.
        </div>
      } @else {
        <div class="message">
          <h2 class="info-title">Account Filters</h2>
          These filters generated with this tool are stored on your pathofexile.com account, but are not yet downloaded on this browser.
          Click the download button to store them in this browser and edit them.
          <span class="extra-info">You can remove filters from your account on your pathofexile.com account page.</span>
        </div>

        <div class="filter-list">
          @for (accountFilter of toolAccountFilters; track accountFilter.id) {
            <div class="filter-item">
              <div class="filter-item-main">
                <div class="filter-name filter-name-readonly" [title]="accountFilter.filter_name">
                  <div class="filter-name-display">{{ accountFilter.filter_name }}</div>
                </div>
                <div class="filter-metadata">
                  <div><span class="extra-info">Version:</span> {{ accountFilter.version }}</div>
                  <div><span class="extra-info">Public:</span> {{ accountFilter.public ? 'Yes' : 'No' }}</div>
                </div>
                <div class="filter-actions tooltip-buttons">
                  <button type="button" class="btn" title="Store in browser" (click)="download(accountFilter)" [disabled]="downloadingFilter">
                    <span class="icon icon-download"></span>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>

        @if (errorDownloadingFilters) {
          <div class="message">
            An error occurred trying to download the filter: {{ errorDownloadingFilters }}
            <br />Please try again later. If the problem persists, contact us on Discord or the official forum thread.
          </div>
        }
      }
    }

    @if (sisterToolFilters || otherFilters) {
      <div class="message">
        <h2 class="info-title">Other Filters</h2>
        @if (sisterToolFilters) {
          <p>These filters are stored on your pathofexile.com account but were generated with our sister website {{ sisterDisplayDomainName }}: {{ sisterToolFilters }}</p>
        }
        @if (otherFilters) {
          <p>These filters are stored on your pathofexile.com account, but are not generated with this tool: {{ otherFilters }}</p>
        }
      </div>
    }


    @if (showForceRefresh) {
      <div class="message">
        <a [href]="null" class="action-link" (click)="retrieveFilters($event)">Force refresh</a>. Only use this if you have synced filters to your account from another browser.
      </div>
    }
  }

  <div class="controls dialog-controls">
    <button type="button" class="btn dialog-btn dialog-cancel-btn" (click)="closeDialog()">
      Close
    </button>

    @if (copyingSections) {
      <button type="button" class="btn dialog-btn dialog-cancel-copy-btn" (click)="copyingSections = false; fromFilter = null;">
        Cancel Copy Sections
      </button>
    }
  </div>

  @if (showImportDialog) {
    <div id="trade" class="block">
      <div class="search-bar top" style="padding: 0px !important;">
        <app-import-filter-dialog
          [clone]="!copyingSections && !refreshingFromOnline"
          [apply]="copyingSections || refreshingFromOnline"
          [refreshFromOnline]="refreshingFromOnline"
          [refreshFromUsername]="toFilter?.importedFromUsername"
          [filterResults]="{
            importedName: fromFilter!.name,
            importFilterSuccess: true,
            importFilterError: null,
            importFilterMigratedFrom: null,
            importFilterMigratedTo: null,
            importFilterExportDate: null,
            importFilterExportVersion: null,
            importFilterExportGame: null,
            filter: fromFilter!.filter!
          }"
          [sectionsToUpdate]="importDialogSectionsToUpdate"
          (close)="closeImportDialog()"
          (updateFilter)="updateFilterSections($event)"></app-import-filter-dialog>
      </div>
    </div>
  }

</div>
